<template>
  <div
    class="computer-drop"
    @dragover.prevent
    @drop.stop.prevent="onDrop">
    <Spinner
      v-show="isLoading"
      :speed="1"
      size="huge"
      message="Loading..."
      class="position-absolute inner-Loader"/>
    <div class="computer-zone">
      <span class="computer-badge">
        <icon name="fileUpload"/>
      </span>
      <p class="computer-title">You can drag and drop file to upload</p>
      <span class="computer-or">or</span>
      <label
        class="computer-browse"
        for="audio-file-upload">
        Browse file
      </label>
      <input
        id="audio-file-upload"
        class="computer-input"
        type="file"
        accept=".mp3"
        @change="audioUploaded">
      <span class="computer-hint">MP3</span>
      <div
        v-if="showExtensionError"
        class="upload-alert"
        role="alert">
        <icon name="alert-circle"/>
        <span>Please only upload .mp3 files</span>
      </div>
      <div
        v-if="uploadError"
        class="upload-alert"
        role="alert">
        <icon name="alert-circle"/>
        <span>File cannot be uploaded</span>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import axios from 'axios';

export default {
  name:       'AudioFileSelect',
  components: {
    Spinner,
  },
  data() {
    return {
      isLoading:          false,
      showExtensionError: false,
      modalHidden:        true,
      uploadError:        false,
    };
  },
  mounted() {
    this.modalHidden = false;
    EventBus.$on('abortVideoUpload', this.abortAudioFileUpload);
    EventBus.$on('abortAudioUpload', this.abortAudioFileUpload);
  },
  beforeDestroy() {
    EventBus.$off('abortVideoUpload', this.abortAudioFileUpload);
    EventBus.$off('abortAudioUpload', this.abortAudioFileUpload);
  },
  methods: {
    onDrop(event) {
      const files = event.dataTransfer && event.dataTransfer.files;
      if (!files || !files.length) return;
      this.audioUploaded({ target: { files } });
    },
    async audioUploaded(e) {
      const self              = this;
      this.isLoading          = true;
      this.showExtensionError = false;
      this.uploadError        = false;
      this.modalHidden        = false;
      const file              = e.target.files[0];
      const extension         = file.name.split('.').pop();
      if (extension !== 'mp3') {
        console.log('wrong extension');
        this.isLoading = false;
        alert('Invalid File! (Allowed formats: mp3)');
        return;
      }
      if ((file.size / 1024 / 1024) > 50) {
        this.isLoading = false;
        alert('Audio file size can not be more than 50MB');
        return;
      }
      if (file) {
        const objectURL       = URL.createObjectURL(file);
        const audioPlayer     = document.createElement('audio');
        audioPlayer.src       = objectURL;
        let durationInSeconds = null;
        audioPlayer.addEventListener('loadedmetadata', () => {
          durationInSeconds = audioPlayer.duration;
          console.log('durationInSeconds ', durationInSeconds);

          const audioObj = {
            Name:         file.name,
            thumbnail:    'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
            duration:     durationInSeconds,
            mimeType:     'audio/mp3',
            audioUrl:     objectURL,
            startTime:    0,
            endTime:      durationInSeconds,
            fadeIn:       0,
            fadeOut:      durationInSeconds,
            trimDuration: durationInSeconds,
          };
          self.handleAudioUpload(file, audioObj);
        });

        audioPlayer.remove();
      }
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
    async handleAudioUpload(fileToUpload, audioObj) {
      const reqFormData        = new FormData();
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '21d29854-fb88-45e6-9a12-b1f4e6c67d45';
      reqFormData.append('audio', fileToUpload);
      reqFormData.append('file', fileToUpload);
      const headers = {
        'Content-Type': 'text/plain',
      };
      const url     = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;

      const serverURL = `https://${url}.com/WebServices/UploadAudios.ashx?userId=${userId}`;

      await axios.post(serverURL, reqFormData, { headers })
        .then(async (res) => {
          if (this.modalHidden) return;
          let url = res.data;
          if (url && url != '') {
            url               = url.substring(0, url.indexOf('#'));
            audioObj.audioUrl = url;
            EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, audioObj);
          }
          EventBus.$emit('toggleAudioLeftSectionAccordion', true);
          EventBus.$emit('selectAudioLayerFromLeftSection', true);
          this.$store.commit('setDisplayAddAudioModal', false);
        })
        .catch((e) => {
          throw new Error(e.message);
        });
    },

    abortAudioFileUpload() {
      this.modalHidden = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.computer-drop {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;
}

.computer-zone {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 240px;
  padding: 40px;
  border: 1.5px dashed #D5D9E0;
  border-radius: 14px;
  background: #FBFBFC;
  text-align: center;
}

.computer-badge {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #EAF2FE;
  color: #0B57C2;
}

.computer-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  color: #14161B;
}

.computer-or,
.computer-hint {
  font-size: 13px;
  line-height: 1.3;
  color: #5E6573;
}

.computer-hint {
  font-size: 12.5px;
}

.upload-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 420px;
  margin-top: 4px;
  padding: 8px 12px;
  border-radius: 9px;
  background: #FEF3F2;
  box-shadow: inset 0 0 0 1px #FBC9C4;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #912018;
  text-align: left;
}

.upload-alert ::v-deep .icon,
.computer-badge ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  flex-shrink: 0;
  color: inherit;
}

.upload-alert ::v-deep .icon svg {
  display: block;
  width: 15px;
  height: 15px;
}

.computer-browse {
  height: 38px;
  min-height: 38px;
  min-width: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  background: #fff;
  color: #14161B;
  box-shadow: inset 0 0 0 1px #D5D9E0;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.computer-browse,
.computer-browse:focus {
  border: 0;
  outline: 0;
}

.computer-browse:hover {
  background: #F3F4F6;
}

.computer-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.computer-badge ::v-deep .icon svg {
  display: block;
  width: 26px;
  height: 26px;
}

.inner-Loader {
  height: 100%;
  width: 100%;
  background: rgb(255, 255, 255);
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 56;
}
</style>
